import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import MissionSection from '../components/MissionSection';
import ValuesSection from '../components/ValuesSection';
import TeamSection from '../components/TeamSection';
import PortfolioSection from '../components/PortfolioSection';
import SuccessStoriesSection from '../components/SuccessStoriesSection';
import BrandShowcase from '../components/BrandShowcase';
import ServicesSection from '../components/ServicesSection';
import ChemistryMeetingSection from '../components/ChemistryMeetingSection';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <AboutSection />
      <MissionSection />
      <ValuesSection />
      <TeamSection />
      <PortfolioSection />
      <SuccessStoriesSection />
      <BrandShowcase />
      <ServicesSection />
      <ChemistryMeetingSection />
      <ContactSection />
    </main>
  );
};

export default HomePage;
